module.exports = __webpack_public_path__ + "media/images/bookings/childcare/pro_recommendation_sticker@3x-c0020952e7e6d15534bc19f618e9a958.png";